import GbtaQuestions from 'root/rfp-hotel/gbta-questions';

const EXTENDED_GBTA_QUESTIONS = [
  ...GbtaQuestions,
  'RB_COMMENT', // RateQuick Response Comment
  'MESSAGE', // Negotiation Message
];

const PROP_CODES = ['SABRE_PROPCODE', 'PROPCODE', 'INTERNALHOTELCODE'];

export function prepareUploadedRows(uploadedRows){
  return uploadedRows.reduce((responses, row) => {
    const response = parseAnswers(row);
    if(response){
      const propCodes = createResponsePropCodesCache(response);
      const message = readMessage(response);
      responses.push({propCodes, data: { message, response }});
    }
    return responses;
  }, []);
}

export function createResponsePropCodesCache(response){
  return PROP_CODES.reduce((acc, code) => {
    const codeValue = response[code];
    if(codeValue){
      acc[code] = trimCode(codeValue);
    }
    return acc;
  }, {});
}


function parseAnswers(row){
  if(!row) return null;

  const keys = Object.keys(row);
  const parsed = keys.reduce((acc, key) => {
    if(EXTENDED_GBTA_QUESTIONS.includes(key)){
      const value = row[key];
      if(!(value == null || value === '')){
        acc[key] = `${value}`.trim();
      }
    }
    return acc;
  }, {});

  return Object.keys(parsed).length? parsed: null;
}

function readMessage(response){
  if(response.hasOwnProperty('MESSAGE')){
    const message = response.MESSAGE;
    delete response.MESSAGE;
    return message;
  } else {
    return undefined;
  }
}

function trimCode(code){
  return code? `${code.trim()}`.replace(/^0+/, ''): null;
}

